/**
 * Lavespera Discount Popup
 */
class LavesperaDiscountPopup {
  constructor(container) {
    this.overlay = container;
    if (!this.overlay) return;

    this.closeBtn = this.overlay.querySelector('.lavespera-discount-close');
    this.dismissBtns = this.overlay.querySelectorAll('.lavespera-discount-dismiss');
    this.codeBox = this.overlay.querySelector('.lavespera-discount-code-box');
    this.copiedMsg = this.overlay.querySelector('.lavespera-discount-copied');

    this.emailScreen = this.overlay.querySelector('#discountEmailScreen');
    this.codeScreen = this.overlay.querySelector('#discountCodeScreen');
    this.emailInput = this.overlay.querySelector('#discountEmailInput');
    this.submitBtn = this.overlay.querySelector('#discountSubmitBtn');
    this.emailError = this.overlay.querySelector('#discountEmailError');

    this.usedEmails = JSON.parse(localStorage.getItem('lavespera_discount_emails') || '[]');

    this.bindEvents();
    this.checkAutoShow();
  }

  bindEvents() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    this.dismissBtns.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', () => this.handleSubmit());
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.handleSubmit();
        }
      });
    }

    if (this.codeBox) {
      this.codeBox.addEventListener('click', () => this.copyCode());
    }

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    if (this.overlay) {
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    if (this.overlay) {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
      localStorage.setItem('lavespera_discount_popup_shown', 'true');
    }
  }

  handleSubmit() {
    const email = this.emailInput?.value?.trim().toLowerCase();

    if (!email || !this.isValidEmail(email)) {
      this.showError('Lütfen geçerli bir e-posta adresi girin.');
      this.emailInput?.focus();
      return;
    }

    if (this.usedEmails.includes(email)) {
      this.showError('Bu e-posta adresi ile daha önce kod alınmış.');
      return;
    }

    this.clearError();
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = '...';

    this.subscribeEmail(email).then(() => {
      this.saveEmail(email);
      this.showCodeScreen();
    }).catch(() => {
      this.saveEmail(email);
      this.showCodeScreen();
    });
  }

  subscribeEmail(email) {
    const formData = new FormData();
    formData.append('form_type', 'customer');
    formData.append('utf8', '\u2713');
    formData.append('contact[email]', email);
    formData.append('contact[tags]', 'newsletter, discount-popup');

    return fetch('/contact', {
      method: 'POST',
      body: formData
    });
  }

  saveEmail(email) {
    this.usedEmails.push(email);
    localStorage.setItem('lavespera_discount_emails', JSON.stringify(this.usedEmails));
  }

  showError(msg) {
    if (this.emailError) this.emailError.textContent = msg;
  }

  clearError() {
    if (this.emailError) this.emailError.textContent = '';
  }

  showCodeScreen() {
    if (this.emailScreen) this.emailScreen.style.display = 'none';
    if (this.codeScreen) this.codeScreen.style.display = 'flex';
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  copyCode() {
    const codeText = this.codeBox?.dataset.code;
    if (!codeText) return;

    navigator.clipboard.writeText(codeText).then(() => {
      if (this.copiedMsg) {
        this.copiedMsg.classList.add('show');
        setTimeout(() => {
          this.copiedMsg.classList.remove('show');
        }, 2000);
      }
    });
  }

  checkAutoShow() {
    // Popup artık sayfa yükünde değil, sepete ürün eklenince açılıyor.
  }

  showOnCartAdd() {
    const showOnce = this.overlay.dataset.showOnce === 'true';
    if (showOnce && localStorage.getItem('lavespera_discount_popup_shown') === 'true') return;
    const delay = parseInt(this.overlay.dataset.autoShowDelay || '3') * 1000;
    setTimeout(() => this.open(), delay);
  }
}

/* Cart add interceptor */
const _originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
  return _originalFetch.apply(this, args).then(response => {
    if (url.includes('/cart/add') && response.ok && window.lavesperaDiscountPopup) {
      window.lavesperaDiscountPopup.showOnCartAdd();
    }
    return response;
  });
};

/* Initialize */
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('discountPopupOverlay');
  if (container) {
    window.lavesperaDiscountPopup = new LavesperaDiscountPopup(container);
  }
});

/* Shopify Theme Editor Support */
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('#discountPopupOverlay');
  if (container) {
    window.lavesperaDiscountPopup = new LavesperaDiscountPopup(container);
  }
});

document.addEventListener('shopify:section:select', (event) => {
  const container = event.target.querySelector('#discountPopupOverlay');
  if (container && window.lavesperaDiscountPopup) {
    window.lavesperaDiscountPopup.open();
  }
});

document.addEventListener('shopify:section:deselect', (event) => {
  const container = event.target.querySelector('#discountPopupOverlay');
  if (container && window.lavesperaDiscountPopup) {
    window.lavesperaDiscountPopup.close();
  }
});
